import { Component, OnInit } from '@angular/core';
import { PageComponent } from '@icc/configurator/shared';
import { _ } from "@icc/shared/helpers";

@Component({
    selector: 'icc-drives-accessories-page',
    templateUrl: './drives-accessories-page.component.html',
    styleUrls: ['./drives-accessories-page.component.scss'],
    standalone: false
})
export class DrivesAccessoriesPageComponent extends PageComponent implements OnInit {
    public title = _('ROLLER_SHUTTER_LEGACY|Wybierz dodatek');

    constructor() {
        super();
    }

    ngOnInit() {}
}
